// src/pages/Help.js

import React from "react";

export default function Help() {
  return (
    <div>
      <h1>Help</h1>
      <p>

StaffIQ is een slim en praktisch CRM-systeem voor het MKB.<br />
Het systeem is ontwikkeld voor handels- en productiebedrijven, personele dienstverlening en projectmatig werkende bedrijven.<br />
Je werkt op eenvoudige wijze met geïntegreerde AI en directe koppelingen, die dagelijkse handelingen sneller en eenvoudiger maken. 
Het systeem bestaat op dit moment uit onderdelen voor:
      <ul>
        <li>Organisaties / Relaties</li>
        <li>Contactpersonen</li>
        <li>Personeel</li>
        <li>Personeelsmatching</li>
        <li>Notities / Taken</li>
        <li>Documentbeheer</li>
        <li>Projectbeheer</li>
        <li>Offertes / Opdrachten / Projectregistratie</li>
        <li>Facturering</li>
      </ul>
Wekelijks wordt er nieuwe functionatiteit toegevoegd.<br />
<br />
De knop Spreek kan gebruikt worden, wanneer de browser spreekondersteuning heeft.<br />
Voor iedere rubriek dient Spreek geactiveerd te worden.<br />
<br />
Spraakcommando’s:
      <ul>
        <li>volgende</li>
        <li>vorige / terug</li>
        <li>nieuw</li>
        <li>vernieuw</li>
        <li>item / selecteer / rechts</li>
        <li>lijst / links</li>
        <li>leeg</li>
        <li>punt</li>
        <li>klaar</li>
        <li>open</li>
        <li>stop / klaar</li>
        <li>ja/nee / aan/uit</li>
      </ul>

De structuur is eenvoudig van opzet en alle functies hebben dezelfde indeling.<br />
De layout wordt automatisch aangepast als je op je smartphone of op een tablet wilt werken.<br />
<br />
Op de laptop / PC is de standaard indeling als volgt:<br />
Links het Menu.<br />
Midden het overzicht van de gegevens met sorteer- en filteropties.<br />
Na het klikken op een regel wordt het invoerblok ingevuld en kun je wijzigingen doorvoeren.<br />
Als je klikt op een telefoonnummer, dan kun je dit nummer bellen.<br />
Als je klikt op een mobiel nummer, dan kun je bellen, WhatsAppen of een SMS sturen.<br />
Als je klikt op een e-mail adres, dan wordt het e-mail programma geopend.<br />
Rechts het invoerblok met onder elkaar de verschillende items.<br />
Indien er meer ruimte nodig is voor de invoer of raadpleging van gegevens, dan wordt er automatisch een popup getoond.<br />
De namen van de rubrieken spreken voor zich.<br />
<br />
Op de smartphone staan het overzicht en het invoerblok onder elkaar.<br />
Het menu roep je op door op de 3 streepjes links boven te klikken.<br />
<br />
Het menu bestaat op dit moment uit 2 delen.<br />
CRM met een pijltje naar rechts.<br />
Als je op dit pijltje klikt, dan kom je terecht in het menu HRM.<br />
Met het pijltje naar links kun je weer terug naar het CRM gedeelte.<br />
<br />
Het systeem vult zoveel mogelijk gegevens in de programma's automatisch in.<br />
Die gegevens kun je dan wel altijd weer overschrijven.<br />
De gegevens uit de organisatie worden zoveel mogelijk als basis gebruikt voor offertes, opdrachten en facturen.<br />
<br />
Notities en Taken vind je binnen dezelfde functie.<br />
Het belangrijkste verschil is, dat het systeem je herinnert aan openstaande taken.<br />
Je krijgt een melding van je openstaande taken als je inlogt in het systeem.<br />
En, indien gewenst, dan kun je automatisch een herinnering per e-mail naar jezelf laten sturen.<br />
Dit wordt iedere dag om 10.00 uur herhaald, tot de taak de status "Klaar" krijgt.<br />
<br />
Alle documenten kunnen worden opgeslagen en opgehaald worden vanaf een vaste map per klant of personeelslid.<br />
Deze mappen worden door het systeem automatisch aangemaakt op een plaats die is vastgelegd bij de instellingen.<br />
Dit kan lokaal zijn, of in de cloud, afhankelijk van de gemaakte keuze.<br />
Alleen de administrator kan de instellingen aanpassen.<br />
Ook de met StaffIQ gemaakte documenten, zoals offertes, opdrachten, facturen en personeelsdocumenten worden automatisch in de klantenmap geplaatst.<br />
<br />
Projecten en deelprojecten kunnen in niveaus worden vastgelegd.<br />
Je kunt hierbij zelf een nummersysteem opzetten, bijvoorbeeld 01 / 01.01 / 01.02.<br />
Hierbij kun je ook kiezen voor 3 voorloopnullen als er meer dan 100 lagen zijn.<br />
Er kan indien gewenst een prijs voor het deelproject worden ingevoerd.<br />
Maar je kunt er natuurlijk ook voor kiezen om een prijs per kg of per m2 in te voeren.<br />
Dit kan dan het beste in de tekst worden vermeld.<br />
Er is tekst die op de offerte/opdracht/factuur wordt vermeld, maar je kunt ook tekst toevoegen voor intern gebruik.<br />
Een project of deelproject kan worden gekopieerd en dan aangepast. Op deze manier kun je snel nieuwe projecten definiëren<br />
<br />

Je kunt een nieuwe offerte aanpassen en uitprinten, en ook automatisch per e-mail versturen naar de klant.<br />
Als de offerte goedgekeurd is, dan wordt hij omgezet naar een opdracht.<br />
Deze opdracht kan worden geprint, of per e-mail als bevestiging naar de klant worden gestuurd.<br />
En vervolgens resulteert een goedgekeurde opdracht in een (concept)factuur.<br />
<br />
In de functie facturen kan de concept factuur worden gecontroleerd en vervolgens definitief worden gemaakt,<br />
Daarna krijgt hij een factuurnummer en kan worden geprint of per e-mail naar de klant worden gestuurd.<br />
De (deel)betalingen kunnen in het Facturen programma worden bijgehouden.<br />
<br /><br />
De volgende onderdelen zijn in ontwikkeling en wekelijks worden nieuwe programma's aan StaffIQ toegevoegd.
      <ul>
        <li>Urenregistratie</li>
        <li>Planning</li>
        <li>Bezettingsoverzicht</li>
        <li>Materiaal / Producten / Stuklijst</li>
        <li>Inkoop</li>
        <li>Magazijn / Voorraad</li>
        <li>Kostprijsberekening / Voorcalculatie</li>
        <li>Pakbon</li>
        <li>Materiaal registratie</li>
        <li>Bezetting en Logistiek</li>
        <li>Nacalculatie</li>
        <li>Management informatie</li>
        <li>Dashboard</li>
      </ul>
<br /><br />

Wij staan open voor goede suggesties, en blijven nieuwe onderdelen voor StaffIQ ontwikkelen.
Graag ontvangen wij uw ideeën per e-mail info@staffiq.nl of via onze website www.staffiq.nl.

      </p>
    </div>
  );
}